var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.5,
    height: 33,
    viewBox: "0 0 36.5 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6fb32f;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.b{fill:#ffc13d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4197.5 5415.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4198 -5415.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,32A16,16,0,1,1,32,16,16.018,16.018,0,0,1,16,32ZM.661,16h0A15.355,15.355,0,0,0,16,31.337,15.355,15.355,0,0,1,.662,16ZM10,15a1,1,0,0,0-.625,1.781l5,4a1,1,0,0,0,1.376-.122l7-8a1,1,0,0,0-1.5-1.318l-6.371,7.281-4.253-3.4A1,1,0,0,0,10,15Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(4224 -5412)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildInProgress);
export default __webpack_public_path__ + "static/media/build-in-progress.72aa79665fc855c4f6fa21fad38586c0.svg";
export { ForwardRef as ReactComponent };